import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/layout/Layout';
import { Search, Star, MapPin } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CoachesPage() {
  const [coaches, setCoaches] = useState(null);
  const [featured, setFeatured] = useState([]);
  const [q, setQ] = useState('');

  const load = (query = '') => {
    axios.get(`${API}/api/coaches${query ? `?q=${encodeURIComponent(query)}` : ''}`).then(r => setCoaches(r.data)).catch(() => setCoaches([]));
  };
  useEffect(() => {
    load();
    axios.get(`${API}/api/coaches/featured?limit=3`).then(r => setFeatured(r.data || [])).catch(() => setFeatured([]));
  }, []);

  return (
    <Layout title="Coaches">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 py-12">
        <div className="flex items-start justify-between flex-wrap gap-4 mb-8">
          <div>
            <h1 className="text-4xl sm:text-5xl font-bold text-[#0A0F1C] mb-2">Our Coaches</h1>
            <p className="text-[#475569]">Work with vetted business strategists and entrepreneurship coaches.</p>
          </div>
          <Link to="/coaches/apply" className="btn-outline text-sm" data-testid="apply-coach-cta">Apply to coach →</Link>
        </div>

        {/* Top-rated spotlight — strengthens the lead-gen funnel */}
        {!q && featured.length > 0 && (
          <div className="mb-10" data-testid="top-rated-strip">
            <div className="flex items-center gap-2 mb-4">
              <Star size={16} className="text-[#F97316] fill-[#F97316]" />
              <h2 className="text-lg font-bold text-[#0A0F1C]">Top-rated coaches</h2>
            </div>
            <div className="grid md:grid-cols-3 gap-4">
              {featured.map((c, i) => (
                <Link to={`/coaches/${c.slug}`} key={c.coach_id || i} className="block bg-gradient-to-br from-[#0A0F1C] to-[#1D2A44] text-white rounded-2xl p-5 hover:shadow-xl transition-shadow" data-testid={`top-coach-${i}`}>
                  <div className="flex items-center gap-3 mb-3">
                    {c.photo_url ? <img src={c.photo_url} alt={c.name} className="w-14 h-14 rounded-full object-cover border-2 border-white/20" /> : <div className="w-14 h-14 rounded-full bg-[#F97316] text-white flex items-center justify-center text-xl font-bold">{c.name?.[0]}</div>}
                    <div className="min-w-0">
                      <div className="font-bold truncate">{c.name}</div>
                      {c.avg_rating != null ? (
                        <div className="flex items-center gap-1 text-sm text-white/80"><Star size={13} className="text-[#F97316] fill-[#F97316]" /><span className="font-bold text-white">{c.avg_rating}</span><span className="text-white/50">({c.review_count})</span></div>
                      ) : <span className="text-xs text-white/50">New coach</span>}
                    </div>
                  </div>
                  {c.headline && <div className="text-sm text-white/80 line-clamp-2">{c.headline}</div>}
                </Link>
              ))}
            </div>
          </div>
        )}

        <form onSubmit={e => { e.preventDefault(); load(q); }} className="relative mb-8 max-w-md">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
          <input className="w-full pl-9 pr-3 py-2.5 border border-[#E2E8F0] rounded-lg text-sm" placeholder="Search by name or expertise…" value={q} onChange={e => { setQ(e.target.value); load(e.target.value); }} data-testid="coach-search" />
        </form>

        {coaches === null && <div className="text-center text-[#94A3B8] py-12">Loading…</div>}
        {coaches && coaches.length === 0 && <div className="text-center text-[#94A3B8] py-12" data-testid="coaches-empty">No coaches found.</div>}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {(coaches || []).map(c => (
            <Link to={`/coaches/${c.slug}`} key={c.coach_id} className="block bg-white border border-[#E2E8F0] rounded-2xl p-5 hover:shadow-lg transition-shadow" data-testid={`coach-card-${c.slug}`}>
              <div className="flex items-center gap-3 mb-3">
                {c.photo_url ? <img src={c.photo_url} alt={c.name} className="w-14 h-14 rounded-full object-cover" /> : <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#1D4ED8] to-[#F97316] text-white flex items-center justify-center text-xl font-bold">{c.name[0]}</div>}
                <div>
                  <div className="font-bold text-[#0A0F1C] flex items-center gap-1">{c.name}{c.is_featured && <Star size={13} className="text-[#F97316] fill-[#F97316]" />}</div>
                  {c.location && <div className="text-xs text-[#94A3B8] flex items-center gap-1"><MapPin size={11} />{c.location}</div>}
                </div>
              </div>
              {c.headline && <div className="text-sm font-medium text-[#334155] mb-2">{c.headline}</div>}
              <div className="flex gap-1 flex-wrap">{(c.expertise || []).slice(0, 4).map(e => <span key={e} className="text-[11px] bg-[#F1F5F9] px-2 py-0.5 rounded">{e}</span>)}</div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}
